import { roleSchema, transferTypeSchema } from './transportExecution.availableActions.schema';
import { z } from 'zod';

export const reportedBySchema = z.object({
    role: roleSchema,
    duns: z.string(),
});

export const confirmShipmentTransferRequestSchema = z.object({
    transferred_at: z.iso.datetime(),
    transfer_type: transferTypeSchema,
    transport_leg_id: z.string(),
    reported_by: reportedBySchema,
});

// For the confirm transfer endpoint, the response is 202 Accepted with no body
export const confirmShipmentTransferResponseSchema = z.union([z.void(), z.null()]);

export type ApiConfirmShipmentTransferRequest = z.infer<typeof confirmShipmentTransferRequestSchema>;
export type ApiReportedBy = z.infer<typeof reportedBySchema>;
